module.exports = __webpack_public_path__ + "static/media/28-roz-office-12_04_2020.52fef1f2.jpeg";